import { ICellRendererParams } from 'ag-grid-community'
import { WbsItemIcon } from '../../../../../components/icons/WbsItemIcon'
import { CellRendererRoot } from '.'
import { styled } from '@mui/material'
import { colorPalette } from '../../../../../style/colorPalette'
import { WbsItemTypeVO } from '../../../../../../domain/value-object/WbsItemTypeVO'

type ProjectPlanRowBase = {
  wbsItem?: { wbsItemType?: WbsItemTypeVO }
}
type ProjectPlanNameCellRendererProps = ICellRendererParams<ProjectPlanRowBase>

export const ProjectPlanNameCellRenderer = ({
  value,
  data,
}: ProjectPlanNameCellRendererProps) => {
  // 解決済みの wbsItemType を使う (snapshot の type 再解決は workgroup を誤判定するため)
  const type = data?.wbsItem?.wbsItemType

  return (
    <CellRendererRoot>
      <IconWrapper>
        <WbsItemIcon type={type} />
      </IconWrapper>
      <Name>{value}</Name>
    </CellRendererRoot>
  )
}

const IconWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
})
const Name = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  color: colorPalette.monotone[9],
  fontSize: '14px',
  lineHeight: 1,
  padding: '0 6px',
})
